import { defaultHeaders } from './common';

export const getListExemptionConf = () => {
  return {
    method: 'get',
    url: '/api/exemption',
    headers: defaultHeaders,
  };
};
